<template>
    <div class='container'></div>
</template>

<script>
import DatasetService from 'src/services/dataset'
const { buildDataAppViewUrl } = require('src/mixins/utils');

export default {
    async mounted() {
        const datasetPublicId = this.$route.params.datasetPublicId;
        const projectName = this.$route.params.projectName.toLowerCase();

        const datasetDetails = await DatasetService.getDatasetByPublicId(datasetPublicId);
        const standardDataApps = datasetDetails.statisticalInfo?.standardDataApps
          || datasetDetails.standardDataApps;

        if (!standardDataApps) {
            return;
        }

        const projectMatch = standardDataApps.find((app) => {
            return app.id.toLowerCase() == projectName;
        });

        if (!projectMatch) {
            return;
        }

        document.title = projectMatch.name + " - " + datasetDetails.name;
        window.location.replace(buildDataAppViewUrl(projectMatch, datasetPublicId));
    }
}
</script>

<style>
</style>
